import React, { Component } from 'react'
import SRCards from '../../components/SRCards'
import EstimateApi from '../../services/estimate.service'
import {
    Button, Container, Paper, TableContainer, TextField, Table,
    TableHead, TableRow, TableCell, TableBody, TableFooter,
    Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Typography
} from '@material-ui/core'
import { Alert } from '@material-ui/lab';

type IProps = {
    location: any
}
type IState = {
    estimates: any;
    dialog: any;
    confirmMsg: any;
    pageResponse: any;
    snackBar: any;
    searchValue: any;
    estimateToBeDeleted: any;
}
const apiservices = new EstimateApi();

class EstimateList extends Component<IProps, IState> {
    constructor(props: any) {
        super(props);
        this.state = {
            estimates: [],
            dialog: false,
            confirmMsg: null,
            pageResponse: null,
            snackBar: '',
            searchValue: null,
            estimateToBeDeleted: null
        };
    }

    async onSearch(e: any) {
        if (e.key === 'Enter') {
            const response = await apiservices.getEstimates(
                e.target.value
            );
            this.setState({
                estimates: response,
                searchValue: e.target.value
            })
        }
    }

    async confirm(estimateId: any, estimateNumber: any) {
        let res = `This operation will delete estimate - ${estimateNumber} 
                    along with its items.`
        this.setState({
            dialog: true,
            confirmMsg: res,
            estimateToBeDeleted: estimateId
        })
        return
    }

    async cancel() {
        this.setState({
            dialog: false,
            snackBar: 'info',
            pageResponse: `Deletion Cancelled.`
        })
    }

    async delete() {
        const { estimateToBeDeleted, searchValue } = this.state;
        let response = await apiservices.deleteEstimates(estimateToBeDeleted);
        if (response && response.id) {
            const updated = await apiservices.getEstimates(
                searchValue
            );
            this.setState({
                dialog: false,
                snackBar: 'success',
                pageResponse: "Deleted Successfully.",
                estimates: updated
            })
        }
        else {
            let msg;
            if(response && response.message && response.description) {
                msg = `Delete Failed: ${response.message} - ${response.description}`
            } else {
                msg = `Delete Failed.`
            }
            this.setState({
                dialog: false,
                snackBar: 'error',
                pageResponse: msg
            })
        }
    }

    render() {
        return (
            <div>
                <SRCards />
                <Container>
                    <Typography
                        style={{
                            padding: 16
                        }}
                    >
                        {localStorage.getItem('selectedCompanyDisplay')}
                    </Typography>
                    <TextField
                        style={{ padding: 20 }}
                        variant="outlined"
                        onKeyDown={(e) => this.onSearch(e)}
                        placeholder='Search Estimate..' />
                    <TableContainer
                        component={Paper}
                        style={{
                            width:1500
                        }}
                    >
                        <Table
                            style={{
                                minWidth: 700,
                            }}
                            aria-label="customized table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Action</TableCell>
                                    <TableCell>Estimate</TableCell>
                                    <TableCell>Estimate Date</TableCell>
                                    <TableCell>Customer Name</TableCell>
                                    <TableCell>Customer Location</TableCell>
                                    <TableCell>Job Type</TableCell>
                                    <TableCell>Estimated Hours</TableCell>
                                    <TableCell>Sub Total</TableCell>
                                    <TableCell>Tax</TableCell>
                                    <TableCell>Total</TableCell>
                                    <TableCell>Estimate Status</TableCell>
                                </TableRow>
                            </TableHead>
                            {this.state.estimates.length > 0 ?
                                this.state.estimates.map((estimate: any) => {
                                    return (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>
                                                    <Button
                                                        style={{ margin: 10 }}
                                                        variant='outlined'
                                                        onClick={this.confirm.bind(
                                                            this, 
                                                            estimate.id, 
                                                            estimate.estimateNumber
                                                            )
                                                        }
                                                    >
                                                        Delete
                                                    </Button>
                                                </TableCell>
                                                <TableCell>
                                                    {estimate.estimateNumber}
                                                </TableCell>
                                                <TableCell>
                                                    {estimate.estimateDate}
                                                </TableCell>
                                                <TableCell>
                                                    {
                                                    estimate.serviceAddress?
                                                    estimate.serviceAddress.customerId?
                                                    estimate.serviceAddress.customerId.name?
                                                    estimate.serviceAddress.customerId.name:
                                                    estimate.serviceAddress.customerId.displayName?
                                                    estimate.serviceAddress.customerId.displayName:
                                                    estimate.serviceAddress.customerId.firstname+' '+estimate.serviceAddress.customerId.lastname:
                                                    '-':
                                                    '-'
                                                    }
                                                </TableCell>
                                                <TableCell>
                                                    {estimate.serviceAddress.addressLine1},
                                                    {estimate.serviceAddress.city},
                                                    {estimate.serviceAddress.state},
                                                    {estimate.serviceAddress.zipcode}
                                                </TableCell>
                                                <TableCell>
                                                    {estimate.jobType}
                                                </TableCell>
                                                <TableCell>
                                                    {estimate.estimatedHours}
                                                </TableCell>
                                                <TableCell>
                                                    {estimate.subTotal}
                                                </TableCell>
                                                <TableCell>
                                                    {estimate.tax}
                                                </TableCell>
                                                <TableCell>
                                                    {estimate.total}
                                                </TableCell>
                                                <TableCell>
                                                    {estimate.estimateStatus}
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    )
                                }) : null}
                            <TableFooter>
                                <TableRow>

                                </TableRow>
                            </TableFooter>
                        </Table>
                    </TableContainer>
                    <Dialog
                        open={this.state.dialog}
                        onClose={() => {
                            this.setState({
                                dialog: false
                            })
                        }}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description">
                        <DialogTitle id="alert-dialog-title">
                            {'Confirmation!'}
                        </DialogTitle>
                        <DialogContent>
                            {this.state.confirmMsg}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={
                                    () => {
                                        this.setState({
                                            confirmMsg:'Processing...'
                                        })
                                        this.delete()
                                    }
                                }
                            >
                                Confirm
                                </Button>
                            <Button
                                onClick={
                                    () => this.cancel()
                                }
                                autoFocus
                            >
                                Cancel
                                </Button>
                        </DialogActions>
                    </Dialog>
                    <Snackbar
                        open={this.state.snackBar === '' ? false : true}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'right',
                        }}
                        autoHideDuration={6000}
                        onClose={() => {
                            this.setState({
                                snackBar: ''
                            })
                        }}
                    >
                        <Alert
                            severity={this.state.snackBar}
                            onClose={() => {
                                this.setState({
                                    snackBar: ''
                                })
                            }
                            }>
                            {this.state.pageResponse}
                        </Alert>
                    </Snackbar>
                </Container>
            </div>
        )
    }
}

export default EstimateList;